import * as React from 'react';
import { useSelector } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import { getCurrentStepName } from '../state/selectors.internal.js';
import { usePrivateSteppingContext } from './PrivateSteppingContext.js';

const CurrentStepContext = /*#__PURE__*/ React.createContext(null);
/**
 * This hook is not exported outside of this module. It is not meant to be used by consumers.
 */ const useCurrentStepContext = ()=>{
    const context = React.useContext(CurrentStepContext);
    if (context === null) {
        throw Error(`Consumer of useSteppingContext needs to be wrapped in a CurrentStepContext provider.`);
    }
    return context;
};
const CurrentStepContextProvider = ({ children ,  })=>{
    const { stepsMap , selectorProps  } = usePrivateSteppingContext();
    const currentStepName = useSelector((s)=>getCurrentStepName(s, selectorProps)
    );
    if (!isDefined(currentStepName)) {
        throw new Error(`currentStepName must be defined. However, "${currentStepName}" was received.`);
    }
    const currentStep = stepsMap[currentStepName];
    if (!isDefined(currentStep)) {
        throw new Error(`currentStep must be defined. However, "${currentStep}" was received.`);
    }
    const context = {
        currentStep,
        currentStepName
    };
    return /*#__PURE__*/ React.createElement(CurrentStepContext.Provider, {
        value: context
    }, children);
};

export { CurrentStepContext, CurrentStepContextProvider, useCurrentStepContext };
//# sourceMappingURL=CurrentStepContext.js.map
